import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../store/auth.store';
import { X, Info } from 'lucide-react';
import { safeSessionStorage } from '../../utils/safeStorage';

export const EmailVerificationBanner: React.FC = () => {
    const { t } = useTranslation();
    const { user, isAuthenticated } = useAuthStore();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Only show if user is authenticated AND email is NOT verified
        // AND banner hasn't been dismissed in this session
        // Note: checking explicit false check or absence of true if the API returns boolean
        if (isAuthenticated && user && !user.emailVerified) {
            const dismissed = safeSessionStorage.getItem('email_banner_dismissed');
            if (dismissed !== 'true') {
                setIsVisible(true);
            }
        } else {
            setIsVisible(false);
        }
    }, [isAuthenticated, user]);

    const handleDismiss = () => {
        setIsVisible(false);
        safeSessionStorage.setItem('email_banner_dismissed', 'true');
    };

    if (!isVisible) return null;

    return (
        <div className="bg-blue-50 border-b border-blue-100 flex items-center justify-center px-4 py-2 relative z-50">
            <div className="container mx-auto flex items-center justify-between gap-4 max-w-7xl">
                <div className="flex items-center gap-3 text-blue-800 text-sm font-medium">
                    <Info className="w-5 h-5 text-blue-600 flex-shrink-0" />
                    <span>
                        {t('auth.emailNotVerified')}
                    </span>
                </div>
                <button
                    onClick={handleDismiss}
                    className="text-blue-500 hover:text-blue-700 hover:bg-blue-100 p-1 rounded-full transition-colors flex-shrink-0"
                    aria-label={t('common.close')}
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    );
};
